import { Text } from '@pentabd/ui';

const SiteMaintenance = () => {
  return (
    <div className="d-flex flex-column gap-6 align-items-center text-center">
      <Text size="lg" weight="bold" color="dark" sizeType="display">
        Site is under maintenance
      </Text>
    </div>
  );
};

export default SiteMaintenance;
